export const RouterPaths = {
  Consumptions: '/consumptions',
  Signup: {
    Base: '/signup',
    Form: '/signup',
    PaymentMethodCompletion: '/signup/paymentMethodCompletion',
  },
  EVInvoices: '/evInvoices',
  FAQ: '/faq',
  GasConsumptions: '/gasConsumptions',
  Home: '/',
  Inquiry: '/inquiry',
  Invoices: '/invoices',
  InvoiceSample: '/invoices/sample',
  Login: '/login',
  Maintenance: '/maintenance',
  PasswordMail: '/passwordmail',
  PaymentMethod: '/payment',
  Receipts: '/receipts',
  RegisterPassword: '/registerpassword',
  ResetPassword: '/resetpassword',
  User: {
    Base: '/user',
    Edit: '/user/edit',
    MoveOut: '/user/moveOut',
  },
} as const
